import './SingleVideo.css';
import { useRef } from 'react';
import { canUseDOM, injectImageResolution } from '../../../utils';
import Video from '../../atoms/Video';
import React from 'react';
import ErrorBoundary from '../../atoms/ErrorBoundary/ErrorBoundary';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
const SingleVideo = _ref => {
  let {
    imgSrc2,
    alt2,
    video,
    hasYoutubeVideo,
    title,
    eventsAnalytics,
    params
  } = _ref;
  const imgLoadedEvent = () => {
    if (canUseDOM) {
      const isHeaderGeneric = imageRef.current.closest('.header-generic--primary');
      if (isHeaderGeneric) {
        const animButton = isHeaderGeneric.getElementsByClassName('header-animation-trigger');
        if (animButton && animButton.length) animButton[0].click();
      }
    }
  };
  const imageRef = useRef();
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("div", {
    className: `section-detail-content--single-video-styles section-detail-content--single-video-styles-rtl`
  }, canUseDOM && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("picture", {
    className: 'styled-curved-image'
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    "data-header": "normal",
    srcSet: `${injectImageResolution(imgSrc2, 700, 700)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(imgSrc2, 325, 325)}`,
    ref: imageRef,
    onLoad: imgLoadedEvent,
    alt: alt2,
    "aria-hidden": "true",
    "aria-label": alt2
  })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Video, {
    videoSrc: video,
    videoType: hasYoutubeVideo ? 'external' : 'media',
    structuredScript: true,
    buttonCenterAlignment: true,
    buttonFilled: true,
    click: val => {
      val === 'Play' ? tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['playVideoTitleAnalytics'], params), title.value) : tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['stopVideoTitleAnalytics'], params), title.value);
    }
  })))));
};
const commonStyles = "c167hgq3";
export default SingleVideo;